const genUniqueId = (function () {
	var count = 0;
	return function (id) {
		if (!id) {
			id = 0;
		}
		var value = (id + count++).toString();
		return value;
	};
})();
export default genUniqueId;

export const generateId = (length = 16) => {
	return (
		Math.round(Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))
			.toString(36)
			.slice(1) + new Date().getTime().toString()
	);
};
